export function reduceEpicParams(arrayOfIds) {
  return arrayOfIds?.length
    ? arrayOfIds.reduce((accumulator, currentValue, index) => {
        return {
          ...accumulator,
          [`filter[epic_ids][${index}]`]: currentValue,
        }
      }, {})
    : {}
}

export function reduceTaskParams(arrayOfIds) {
  return arrayOfIds?.length
    ? arrayOfIds.reduce((accumulator, currentValue, index) => {
        return {
          ...accumulator,
          [`filter[task_id][${index}]`]: currentValue,
        }
      }, {})
    : {}
}
